import type {
  NameTemplateFullResponse,
  NameTemplateResponse,
  NameTemplateResponseWithParent,
} from '@/entities/srm/ci';
import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

export class NameTemplatesAPI {
  static getNameTemplateByCitId(
    cit_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<NameTemplateResponse>(
      `/name_template/${cit_id}`,
      options,
    );
  }

  static getNameTemplateWithParent(
    cit_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<NameTemplateResponseWithParent>(
      `/name_template/${cit_id}/with_parent`,
      options,
    );
  }

  static createNameTemplate(
    cit_id: string,
    template: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<NameTemplateResponse>(
      `/name_template/${cit_id}`,
      {
        template: template,
      },
      options,
    );
  }

  static updateNameTemplate(
    cit_id: string,
    payload: {
      template: string;
      like_parent: boolean;
    },
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<NameTemplateResponse>(
      `/name_template/${cit_id}`,
      payload,
      options,
    );
  }

  static deleteNameTemplate(cit_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.delete(`/name_template/${cit_id}`, options);
  }

  static getParentNameTemplate(
    cit_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<NameTemplateFullResponse>(
      `/name_template/${cit_id}/get_parent`,
      options,
    );
  }

  // static makeAsParentNameTemplate(
  //   cit_id: string,
  //   options: AxiosRequestConfig = {},
  // ) {
  //   return srmInstance.put<NameTemplateResponse>(
  //     `/srm/name_template/${cit_id}/make_as_parent`,
  //     null,
  //     options,
  //   );
  // }
}